<template>
  <div></div>
</template>

<script>
export default {
  name: "TicketStatusList"
}
</script>

<style scoped>

</style>